import firebase from 'firebase';
import { FirebaseCourseItem } from '../types/types';
import { isInDevelopment } from './detectEnv';

export const getIcs = async (course: FirebaseCourseItem) =>
  firebase
    .app()
    .functions(isInDevelopment ? undefined : 'europe-west3')
    .httpsCallable('ics')({
      title: course.title,
      start: course.startMoment,
      duration: course.duration,
      url: `${window.location.origin}/public-course/${course.uid}/${course.title
        .trim()
        .split(' ')
        .join('%20')}`,
    })
    .then((result) => {
      if (!result.data.error) {
        const blob = new Blob([result.data], { type: 'text/calendar' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.target = '_blank';
        link.download = `${course.title}.ics`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    });
